import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

import { FORM_SHARES_BASE_URL } from './helpers';
import type { IFormShareListItem } from './types';

export function useFormShares(serviceRequestId: string | null): {
  shares: IFormShareListItem[] | undefined;
  isLoading: boolean;
  error: unknown;
  mutate: KeyedMutator<{ shares: IFormShareListItem[]; count: number }>;
} {
  const { data, error, isLoading, mutate } = useSWR<{
    shares: IFormShareListItem[];
    count: number;
  }>(
    serviceRequestId
      ? `${FORM_SHARES_BASE_URL}?serviceRequestId=${serviceRequestId}`
      : null,
    SWRFetcher({ method: 'GET' })
  );

  return { shares: data?.shares, isLoading, error, mutate };
}
